<script>
export default {
    name: 'IconYoutube'
}
</script>
<template>
    <svg
        class="base-icon icon-youtube"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fill="currentColor" fill-rule="evenodd" d="M58.83 18.259c-.644-2.464-2.542-4.404-4.951-5.063C49.512 12 32 12 32 12s-17.512 0-21.879 1.196c-2.41.659-4.307 2.6-4.95 5.063C4 22.724 4 32.04 4 32.04s0 9.317 1.17 13.782c.644 2.464 2.542 4.323 4.951 4.982C14.488 52 32 52 32 52s17.512 0 21.879-1.196c2.41-.659 4.307-2.518 4.95-4.982C60 41.357 60 32.04 60 32.04s0-9.316-1.17-13.781zm-32.557 22.24V23.582l14.636 8.459-14.636 8.458z"
        />
    </svg>
</template>
